import { render, staticRenderFns } from "./PaymentRelationshipList.vue?vue&type=template&id=010b98c5"
import script from "./PaymentRelationshipList.vue?vue&type=script&lang=js"
export * from "./PaymentRelationshipList.vue?vue&type=script&lang=js"
import style0 from "./PaymentRelationshipList.vue?vue&type=style&index=0&id=010b98c5&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010b98c5')) {
      api.createRecord('010b98c5', component.options)
    } else {
      api.reload('010b98c5', component.options)
    }
    module.hot.accept("./PaymentRelationshipList.vue?vue&type=template&id=010b98c5", function () {
      api.rerender('010b98c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/tabs/PaymentRelationshipList.vue"
export default component.exports